module.exports = __webpack_public_path__ + "img/more-horizontal.5e6b1c66.svg";